<template>
  <el-container>
    <el-main>
      <p v-if="isSearch" class="headTitle">搜索结果：{{ this.searchValue }}</p>
      <p v-else class="headTitle">综合学习</p>
      <div class="headBack">
        <div class="cateListArea" v-if="!isSearch">
          <p
            class="cateItem"
            v-for="item in infoCategoriesList"
            :key="item.id"
            :style="{
              color: item.id == infoCateSelectedID ? '#ffffff' : '#64696f',
              backgroundColor:
                item.id == infoCateSelectedID ? '#4972f0' : 'unset',
            }"
            @click="clickCateTag(item.id)"
          >
            {{ item.name }}
          </p>
        </div>
        <div class="rightBtnArea" v-if="!isSearch && !this.$parent.isMobile">
          <p
            class="cateItemRight"
            :style="{
              color: orderType == 0 ? '#ffffff' : '#64696f',
              backgroundColor: orderType == 0 ? '#4972f0' : 'unset',
            }"
            @click="clickOrderType(0)"
          >
            最新
          </p>
          <p
            class="cateItemRight"
            :style="{
              color: orderType == 1 ? '#ffffff' : '#64696f',
              backgroundColor: orderType == 1 ? '#4972f0' : 'unset',
            }"
            @click="clickOrderType(1)"
          >
            最热
          </p>
        </div>
      </div>
      <div class="line"></div>
      <div class="infoListArea">
        <InformationItem
          v-for="infoItem in infoList"
          :key="infoItem.id"
          :item="infoItem"
          v-on:clickItem="clickArticle"
        />
      </div>
      <div class="pagBack" v-if="!this.$parent.isMobile">
        <el-pagination
          class="pagination"
          :background="isBackground"
          hide-on-single-page
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageIndex"
          :page-size="pageSize"
          layout="prev, pager, next, jumper"
          :total="totalRecord"
        >
        </el-pagination>
      </div>
    </el-main>
  </el-container>
</template>
<script>
import InformationItem from "@/components/InformationItem.vue";
import {
  getArticleList,
  getCategoriesList,
  commitArticleHits,
  searchArticleList,
} from "../service/api";
export default {
  components: { InformationItem },
  data() {
    return {
      isSearch: false,
      searchValue: "",
      isBackground: true,
      dataList: [],
      iconUrl: "",
      cateName: "",
      infoCategoriesList: [],
      infoCateSelectedID: 0,
      infoList: [],
      orderType: 0,
      pageIndex: 1, //分页
      pageSize: 16,
      totalRecord: 0, //总条数
      scrollPosition: 0, //滚动距离
      isLoading: false, //正在加载
    };
  },
  computed: {},
  created() {},
  beforeDestroy() {
    if (this.$parent.isMobile) {
      // 在组件销毁前移除滚动事件监听
      window.removeEventListener("scroll", this.handleScroll);
    }
  },
  mounted() {
    if (this.$parent.isMobile) {
      // 在组件挂载后添加滚动事件监听
      window.addEventListener("scroll", this.handleScroll);
      // 初始化时获取一次滚动位置
      this.getScrollPosition();
    }
    this.$parent.showTopBottomView = true;
    this.$parent.showSearch = true;
    let data = this.$route.query;
    if (data.selectedID != "") {
      this.infoCateSelectedID = data.selectedID;
    }
    if (data.searchValue && data.searchValue != "") {
      this.isSearch = true;
      this.searchValue = data.searchValue;
      this.searchAction();
    } else {
      this.getInfoCategoriesList();
      this.getInfoListAction();
    }
  },
  methods: {
    handleScroll() {
      // 处理滚动事件
      this.getScrollPosition();
    },
    getScrollPosition() {
      // 获取滚动位置
      this.scrollPosition = window.scrollY;
      console.log("this.scrollPosition=", this.scrollPosition);
      if (this.isLoading || this.infoList.length >= this.totalRecord) {
        return;
      }
      if (this.scrollPosition > this.pageHeight - window.innerHeight - 500) {
        this.pageIndex++;
        console.log("加载下一页");
        this.isLoading = true;
        if (this.isSearch) {
          this.searchAction();
        } else {
          this.getInfoListAction();
        }
      }
    },
    getPageHeight() {
      this.pageHeight = Math.max(
        document.documentElement.scrollHeight,
        document.body.scrollHeight
      );
      console.log("页面总高度:", this.pageHeight);
    },
    //搜索
    async searchAction() {
      const res = await searchArticleList(this.pageIndex, this.searchValue);
      console.log("res=", res);
      if (res.data.code === 200 && res.data.success) {
        if (this.pageIndex == 1) {
          this.infoList = res.data.result.records;
        } else {
          this.infoList = this.infoList.concat(res.data.result.records);
        }
        this.totalRecord = res.data.result.total;
        setTimeout(() => {
          this.getPageHeight();
          this.isLoading = false;
        }, 1000);
      } else {
        this.$message({
          message: res.data.message,
          type: "warning",
        });
      }
    },
    //点击文章
    clickArticle(clickItem) {
      const articleID = clickItem.id;
      commitArticleHits(articleID);
      if (clickItem.link && clickItem.link != "") {
        window.open(clickItem.link, "_blank");
      } else {
        this.$router.push({
          path: "/detail",
          query: { articleID: articleID },
        });
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageIndex = val;
      if (this.isSearch) {
        this.searchAction();
      } else {
        this.getInfoListAction();
      }
    },
    //排序
    clickOrderType(orderType) {
      this.orderType = orderType;
      this.getInfoListAction();
    },
    //获取资讯分类
    async getInfoCategoriesList() {
      const res = await getCategoriesList(true);
      console.log("res=", res);
      if (res.data.code === 200 && res.data.success) {
        let cateArray = res.data.result.records;
        cateArray.unshift({ name: "全部", id: 0 });
        this.infoCategoriesList = cateArray;
      } else {
        this.$message({
          message: res.data.message,
          type: "warning",
        });
      }
    },
    //获取分类下资讯
    async getInfoListAction() {
      let order = this.orderType;
      let cateId = this.infoCateSelectedID;
      if (order == 1) {
        order = "hot";
      }
      if (cateId == 0) {
        cateId = "";
      }
      const res = await getArticleList(
        cateId,
        this.pageIndex,
        this.pageSize,
        order
      );
      console.log("res=", res);
      if (res.data.code === 200 && res.data.success) {
        if (this.pageIndex == 1) {
          this.infoList = res.data.result.records;
        } else {
          if (this.$parent.isMobile) {
            this.infoList = this.infoList.concat(res.data.result.records);
          } else {
            this.infoList = res.data.result.records;
          }
        }

        this.totalRecord = res.data.result.total;
        setTimeout(() => {
          this.getPageHeight();
          this.isLoading = false;
        }, 1000);
      } else {
        this.$message({
          message: res.data.message,
          type: "warning",
        });
      }
    },
    clickItem(url) {
      const externalLink = url;
      window.open(externalLink, "_blank");
    },
    //点击资讯分类
    async clickCateTag(selectedID) {
      this.infoCateSelectedID = selectedID;
      this.getInfoListAction();
    },
  },
};
</script>
<style lang="scss" scoped>
.el-main {
  background-color: #f3f5f7;
  position: relative;
  padding: 0px 12.5%;
}
.headBack {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.cateListArea {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 50px;
}
.rightBtnArea {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.cateItem {
  font-size: 18px;
  font-weight: bold;
  margin: 0px 40px 0px 0px;
  padding: 4px 7px;
  height: 30px;
  line-height: 32px;
  cursor: pointer;
  text-align: left;
}
.cateItemRight {
  font-size: 18px;
  font-weight: bold;
  margin: 0px 0px 0px 40px;
  padding: 4px 7px;
  height: 30px;
  line-height: 30px;
  cursor: pointer;
  text-align: right;
}
.headTitle {
  margin-top: 66px;
  font-size: 48px;
  font-weight: bold;
  color: #000000;
  text-align: left;
}
.line {
  background-color: #ebebeb;
  height: 1px;
  width: 100%;
  margin-top: 30px;
}
.infoListArea {
  margin-top: 20px;
  margin-left: -20px;
  margin-right: -20px;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 30px;
  min-height: 900px;
  // width: 100%;
  // flex-direction: row;
  // flex-direction: column;
  // align-items: center;
  // flex: 0 0 25%;
  // justify-content: center;
  // align-items: center;
  // padding: 0px 10px 0px 10px;
}
.pagination {
  margin-top: 40px;
  margin-bottom: 40px;
}
::v-deep .pagination .el-pagination__sizes {
  float: center;
  line-height: 48px;
  height: 48px !important;
}

::v-deep .pagination .el-pagination__total {
  float: left;
  line-height: 48px;
  font-size: 14px;
  height: 48px !important;
}

::v-deep .pagination .el-pagination__jump {
  color: #000000;
  line-height: 48px;
  height: 48px !important;
  font-size: 14px !important;
  // width: 48px !important;
}
::v-deep .pagination .el-pager .number {
  color: #000000 !important; /* 举例: 将文本颜色设为红色 */
  background-color: #ffffff !important;
  width: 48px !important;
  height: 48px !important;
  border-radius: 10px !important;
  border-style: none !important;
  line-height: 48px;
  &.active {
    /* 仅在具有 active 类的情况下应用的样式 */
    color: #ffffff !important; /* 举例: 将文本颜色设为红色 */
    background-color: #4972f0 !important;
    width: 48px !important;
    height: 48px !important;
    border-radius: 10px !important;
    border-style: none !important;
  }
}
::v-deep .pagination .btn-prev {
  /*对上一页的按钮样式进行修改*/
  // background-color: #10263c;
  width: 48px;
  height: 48px;
}
::v-deep .pagination .input {
  background-color: red !important;
}
::v-deep .pagination .btn-next {
  /*对上一页的按钮样式进行修改*/
  // background-color: #10263c;
  width: 48px;
  height: 48px;
}
.pagBack {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
@media screen and (max-width: 768px) {
  .el-main {
    background-color: #f3f5f7;
    position: relative;
    padding: 0px 5%;
  }
  .headBack {
    display: flex;
    flex-direction: row;
    // justify-content: space-between;
  }
  .cateListArea {
    display: flex;
    flex-direction: row;
    // justify-content: flex-start;
    // width: 100%;
    overflow-x: auto;
    // flex-wrap: wrap;
    height: 50px;
  }
  .rightBtnArea {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
  .cateItem {
    font-size: 14px;
    font-weight: bold;
    margin: 0px 10px 0px 0px;
    padding: 4px 7px;
    width: 200px;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
    text-align: center;
    white-space: nowrap;
    // flex: 1;
  }
  .cateItemRight {
    font-size: 18px;
    font-weight: bold;
    margin: 0px 0px 0px 40px;
    padding: 4px 7px;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
    text-align: right;
  }
  .headTitle {
    margin-top: 36px;
    font-size: 30px;
    font-weight: bold;
    color: #000000;
    text-align: left;
    margin-bottom: 30px;
  }
  .line {
    background-color: #ebebeb;
    height: 1px;
    width: 100%;
    // margin-top: 10px;
  }
  .infoListArea {
    margin-top: 20px;
    // margin-left: -12.5%;
    // margin-right: -12.5%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 30px;
    justify-content: center;
    // width: 100%;
    // flex-direction: row;
    // flex-direction: column;
    // align-items: center;
    // flex: 0 0 25%;
    // justify-content: center;
    // align-items: center;
    // padding: 0px 10px 0px 10px;
  }
  .pagination {
    margin-top: 40px;
    margin-bottom: 40px;
  }
  // ::v-deep .pagination .el-pagination__sizes {
  //   float: center;
  //   line-height: 48px;
  //   font-size: 18px !important;
  //   height: 48px !important;
  // }

  // ::v-deep .pagination .el-pagination__total {
  //   float: left;
  //   line-height: 48px;
  //   font-size: 14px;
  //   height: 48px !important;
  // }

  // ::v-deep .pagination .el-pagination__jump {
  //   color: #000000;
  //   line-height: 48px;
  //   height: 48px !important;
  //   font-size: 14px !important;
  //   // width: 48px !important;
  // }
  // ::v-deep .pagination .el-pager .number {
  //   color: #000000 !important; /* 举例: 将文本颜色设为红色 */
  //   background-color: #ffffff !important;
  //   width: 48px !important;
  //   height: 48px !important;
  //   border-radius: 10px !important;
  //   border-style: none !important;
  //   line-height: 48px;
  //   &.active {
  //     /* 仅在具有 active 类的情况下应用的样式 */
  //     color: #ffffff !important; /* 举例: 将文本颜色设为红色 */
  //     background-color: #4972f0 !important;
  //     width: 48px !important;
  //     height: 48px !important;
  //     border-radius: 10px !important;
  //     border-style: none !important;
  //   }
  // }
  // ::v-deep .pagination .btn-prev {
  //   /*对上一页的按钮样式进行修改*/
  //   // background-color: #10263c;
  //   width: 48px;
  //   height: 48px;
  // }
  // ::v-deep .pagination .input {
  //   background-color: red !important;
  // }
  // ::v-deep .pagination .btn-next {
  //   /*对上一页的按钮样式进行修改*/
  //   // background-color: #10263c;
  //   width: 48px;
  //   height: 48px;
  // }
  // .pagBack {
  //   width: 100%;
  //   display: flex;
  //   flex-direction: column;
  //   align-items: center;
  // }
}
</style>
